var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"report_card"},[(_vm.have_data)?_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm._f("round")(_vm.data))+" Accounts / Ledger")]):_vm._e(),_c('br'),_vm._v("\n  New Account Rate\n")])}
var staticRenderFns = []

export { render, staticRenderFns }